












import DimensionServices from '@/services/dimension';
import { SubjectItemDto } from '@/services/subject';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class SubjectForm5 extends Vue {
  @Prop() subSyncDefs!: any;
  @Prop() current!: any;
  @Prop() subFieldList!: SubjectItemDto[];
  loading: boolean = false;

  @Watch('subSyncDefs')
  onChange() {}

  dimSrv = new DimensionServices();

  dataSource: any[] = [];

  get xWidth() {
    return 180 * this.subFieldList.length;
  }

  @Watch('current')
  async onCurrentChange() {
    if (this.current === 4 && this.subSyncDefs.syncMode < 2) {
      this.loading = true;
      let res = await this.dimSrv.excuteSubSql(this.subSyncDefs);
      if (res.header.code == 200) {
        this.dataSource = res.payload.results;
      }
      this.loading = false;
    } else {
      this.dataSource = this.subSyncDefs.inputdataConfig;
    }
  }
}
